import classNames from 'classnames'

export const Video = ({ url, smaller = false }) => {
    const iframeWrapperClasses = classNames({
        'video__iframe-wrapper': true,
        'video__iframe-wrapper--smaller': smaller,
    })

    return (
        <section className="section section--video">
            <div className={iframeWrapperClasses}>
                <iframe
                    src={
                        url +
                        '&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
                    }
                    title="Philips Evnia brand film"
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                    }}
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
        </section>
    )
}
